module.exports = __webpack_public_path__ + "static/media/38.27e36f7a.png";